/**
 * Arbeitszeiten des Betriebs - Grundlage für "Freie Zeiten vorschlagen".
 *
 * Sie liegen im sla-Feld der Firma (dasselbe JSON wie die Automatik-Werte),
 * damit dafür keine eigene Spalte nötig war.
 */

export interface Arbeitszeit {
  tage: number[];      // 1 = Montag ... 7 = Sonntag
  von: string;         // "08:00"
  bis: string;         // "17:00"
  pauseVon: string;    // leer = keine Mittagspause
  pauseBis: string;
  puffer: number;      // Minuten Fahrzeit zwischen zwei Terminen
}

export const ARBEITSZEIT_STANDARD: Arbeitszeit = {
  tage: [1, 2, 3, 4, 5],
  von: "08:00",
  bis: "17:00",
  pauseVon: "12:00",
  pauseBis: "12:30",
  puffer: 30,
};

export const WOCHENTAGE: { nr: number; kurz: string }[] = [
  { nr: 1, kurz: "Mo" }, { nr: 2, kurz: "Di" }, { nr: 3, kurz: "Mi" },
  { nr: 4, kurz: "Do" }, { nr: 5, kurz: "Fr" }, { nr: 6, kurz: "Sa" },
  { nr: 7, kurz: "So" },
];

/** Gespeicherte Werte lesen; alles Fehlende kommt aus dem Standard. */
export function arbeitszeitWerte(sla: unknown): Arbeitszeit {
  const q = ((sla as Record<string, unknown>)?.arbeitszeiten ?? {}) as Partial<Arbeitszeit>;
  return {
    tage: Array.isArray(q.tage) && q.tage.length ? q.tage : ARBEITSZEIT_STANDARD.tage,
    von: typeof q.von === "string" ? q.von : ARBEITSZEIT_STANDARD.von,
    bis: typeof q.bis === "string" ? q.bis : ARBEITSZEIT_STANDARD.bis,
    pauseVon: typeof q.pauseVon === "string" ? q.pauseVon : ARBEITSZEIT_STANDARD.pauseVon,
    pauseBis: typeof q.pauseBis === "string" ? q.pauseBis : ARBEITSZEIT_STANDARD.pauseBis,
    puffer: typeof q.puffer === "number" ? q.puffer : ARBEITSZEIT_STANDARD.puffer,
  };
}
